import { Injectable } from '@angular/core';
import { ChistType, InsertCandidateHistory, InsertWebUserHistory, PortalTypeEnum, WuhType } from '@ats/api/cm';
import { AtsStoreService } from '@ats/store';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { CmSettingsService } from './settings.service';

const INSERT_CANDIDATE_HISTORY = gql`
	mutation insertCandidateHistory($request: InsertCandidateHistory!) {
		insertCandidateHistory(request: $request) {
			cmcId
			created
			creator
			id
			message
			targetId
		}
	}
`;

const INSERT_WEBUSER_HISTORY = gql`
	mutation insertWebUserHistory($request: InsertWebUserHistory!) {
		insertWebUserHistory(request: $request) {
			created
			id
			type
			message
		}
	}
`;

@Injectable({
	providedIn: 'root',
})
export class CmCookiePolicyService {
	constructor(
		private readonly settings: CmSettingsService,
		private readonly storage: AtsStoreService,
		private readonly apollo: Apollo
	) {}

	/**
	 * Gets the name of the store used for storing the store policy acceptance
	 * @method
	 * @return {string} - Returns a string with the name of the store policy store
	 */
	getFromStoreName(id: number): string {
		const prefix = this.settings.portal === PortalTypeEnum.CandidatePortal ? 'C' : 'U';
		return `${prefix}${id}_APN_${this.settings.client}`;
	}

	/**
	 * Checks if the store policy store exists
	 * @method
	 * @return {boolean} - Returns a boolean indicating if the store policy store exists or not
	 */
	hasCookieBeenAccepted(id: number): boolean {
		return !!this.storage.getFromStore(this.getFromStoreName(id));
	}

	/**
	 * Saves the store policy store
	 * @method
	 * @return {void}
	 */
	acceptCookie(id: number): void {
		this.storage.saveToStore(this.getFromStoreName(id), 'CookiePolicyModal', 60 * 24 * 365);
	}

	insertCandidateHistory$(cmcId: number): Observable<any> {
		return this.apollo.mutate<
			{ insertCandidateHistory: InsertCandidateHistory },
			{ request: InsertCandidateHistory }
		>({
			mutation: INSERT_CANDIDATE_HISTORY,
			variables: {
				request: {
					candidateId: {
						cmcId,
					},
					message: 'Candidate has agreed to the store policy.',
					type: ChistType.CookieAgrSigned,
				},
			},
		});
	}

	insertWebUserHistory$(id: number): Observable<any> {
		return this.apollo.mutate<{ insertWebUserHistory: InsertWebUserHistory }, { request: InsertWebUserHistory }>({
			mutation: INSERT_WEBUSER_HISTORY,
			variables: {
				request: {
					webUserId: { id },
					message: 'User has agreed to the store policy.',
					type: WuhType.CookieAgrSigned,
				},
			},
		});
	}
}
